import { LeadForm } from '../components/LeadForm';
import { PageHero } from '../components/PageHero';
import { Section, SectionHeading, Reveal } from '../components/Section';
import { Icon } from '../lib/icons';
import { SEO } from '../lib/seo';

const expectations = [
  {
    title: 'A focused first conversation',
    body: 'We will discuss the business problem, current tools, operational risk, and what a useful next step looks like.'
  },
  {
    title: 'Practical next steps',
    body: 'You may receive a recommendation for discovery, an audit, a scoped project, managed hosting, or support planning.'
  },
  {
    title: 'No generic sales script',
    body: 'The conversation is meant to clarify whether MaytoMation can create measurable operational value.'
  }
];

export function Booking() {
  return (
    <>
      <SEO
        title="Book Consultation"
        description="Request a MaytoMation consultation for Massachusetts software development, automation, infrastructure, AI systems, networking, managed hosting, or support."
      />
      <PageHero
        eyebrow="Booking"
        title="Request a practical technology consultation."
        body="Use this form when you are ready to talk through a project, support need, infrastructure concern, automation opportunity, network issue, or AI system idea."
        secondary={{ label: 'View Services', href: '/services' }}
        highlights={['Software', 'Automation', 'Infrastructure', 'Support']}
      />

      <Section>
        <div className="grid gap-10 lg:grid-cols-[.75fr_1.25fr] lg:items-start">
          <div>
            <SectionHeading
              eyebrow="Consultation"
              title="Send the essentials now. We will use the call for clarity."
              body="The more context you provide, the easier it is to decide whether the right next step is a discovery sprint, audit, scoped build, hosting plan, or retainer."
            />
            <div className="mt-8 grid gap-4">
              {expectations.map((item) => (
                <div key={item.title} className="rounded-lg border border-brand-border bg-white p-5 shadow-card">
                  <Icon name="check" className="h-6 w-6 text-brand-teal" />
                  <h2 className="mt-4 text-lg font-extrabold text-brand-dark">{item.title}</h2>
                  <p className="mt-2 text-sm leading-7 text-brand-muted">{item.body}</p>
                </div>
              ))}
            </div>
          </div>
          <Reveal>
            <LeadForm formType="booking" title="Consultation Request" />
          </Reveal>
        </div>
      </Section>
    </>
  );
}
